import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { appReducer } from './reducers/appSlice';
import { uiReducer } from './reducers/uiSlice';
import { userStateReducer } from './reducers/userSlice';
import { authReducer } from './reducers/authSlice';
import { chatReducer } from './reducers/chatSlice';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const rootReducer = combineReducers({
  app: appReducer,
  UI: uiReducer,
  user: userStateReducer,
  auth: authReducer,
  chat: chatReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  version: 1,
  whiteList: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
